"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCompleteOffsets = void 0;
const getCompleteOffsetsFromValue = (offset) => ({
    top: offset,
    bottom: offset,
    left: offset,
    right: offset,
});
const getCompleteOffsetsFromOffsets = (offset) => {
    var _a, _b, _c, _d;
    return ({
        top: (_a = offset.top) !== null && _a !== void 0 ? _a : 0,
        bottom: (_b = offset.bottom) !== null && _b !== void 0 ? _b : 0,
        left: (_c = offset.left) !== null && _c !== void 0 ? _c : 0,
        right: (_d = offset.right) !== null && _d !== void 0 ? _d : 0,
    });
};
const getCompleteOffsets = (offsets) => {
    if (offsets === undefined) {
        return undefined;
    }
    if (typeof offsets === 'number') {
        return getCompleteOffsetsFromValue(offsets);
    }
    else {
        return getCompleteOffsetsFromOffsets(offsets);
    }
};
exports.getCompleteOffsets = getCompleteOffsets;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib2Zmc2V0cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90eXBlcy9vZmZzZXRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSw0REFBNEQ7OztBQWdCNUQsTUFBTSwyQkFBMkIsR0FBRyxDQUFDLE1BQWMsRUFBbUIsRUFBRSxDQUFDLENBQUM7SUFDdEUsR0FBRyxFQUFFLE1BQU07SUFDWCxNQUFNLEVBQUUsTUFBTTtJQUNkLElBQUksRUFBRSxNQUFNO0lBQ1osS0FBSyxFQUFFLE1BQU07Q0FDaEIsQ0FBQyxDQUFDO0FBRUgsTUFBTSw2QkFBNkIsR0FBRyxDQUFDLE1BQWlDLEVBQW1CLEVBQUU7O0lBQUMsT0FBQSxDQUFDO1FBQzNGLEdBQUcsRUFBRSxNQUFBLE1BQU0sQ0FBQyxHQUFHLG1DQUFJLENBQUM7UUFDcEIsTUFBTSxFQUFFLE1BQUEsTUFBTSxDQUFDLE1BQU0sbUNBQUksQ0FBQztRQUMxQixJQUFJLEVBQUUsTUFBQSxNQUFNLENBQUMsSUFBSSxtQ0FBSSxDQUFDO1FBQ3RCLEtBQUssRUFBRSxNQUFBLE1BQU0sQ0FBQyxLQUFLLG1DQUFJLENBQUM7S0FDM0IsQ0FBQyxDQUFBO0NBQUEsQ0FBQztBQUVJLE1BQU0sa0JBQWtCLEdBQUcsQ0FBQyxPQUE0QyxFQUErQixFQUFFO0lBQzVHLElBQUksT0FBTyxLQUFLLFNBQVMsRUFBRSxDQUFDO1FBQ3hCLE9BQU8sU0FBUyxDQUFDO0lBQ3JCLENBQUM7SUFFRCxJQUFJLE9BQU8sT0FBTyxLQUFLLFFBQVEsRUFBRSxDQUFDO1FBQzlCLE9BQU8sMkJBQTJCLENBQUMsT0FBTyxDQUFDLENBQUM7SUFDaEQsQ0FBQztTQUFNLENBQUM7UUFDSixPQUFPLDZCQUE2QixDQUFDLE9BQU8sQ0FBQyxDQUFDO0lBQ2xELENBQUM7QUFDTCxDQUFDLENBQUM7QUFWVyxRQUFBLGtCQUFrQixzQkFVN0IifQ==